import React from 'react'
import GridViewCell from "./GridViewCell";

const GridViewFooter = ({footerDataItem, visibleFields, mobileMode, readOnly}) => {
    if (!footerDataItem) return null;
    const row = footerDataItem.getRow(0);
    return (
        <tfoot>
            <tr>
                {!readOnly && !mobileMode && <td/>}
                {!mobileMode && visibleFields.map(f => {
                    const style = {textAlign: f['AlignH']};
                    return (<td key={`${f.Name}_footer`} style={style}>
                        <GridViewCell rowIndex={0} fieldInfo={f} dataItem={footerDataItem} readOnly={true} row={row}  />
                    </td>);
                })}
                {mobileMode &&
                    <td className={"grid-footer-inline"}>
                        {visibleFields.map(f => {
                            const style = {textAlign: f['AlignH']};
                            return (<div key={`${f.Name}_footer`} style={style}>
                                <GridViewCell rowIndex={0} fieldInfo={f} dataItem={footerDataItem} readOnly={true} row={row}  />
                            </div>);
                        })}
                    </td>
                }
            </tr>
        </tfoot>
    );
}

export default GridViewFooter;